import React from "react";
import TankLevel from "./tank_level.jsx";
import Table from "../../controls/table/table";
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import { withRouter } from 'react-router-dom';
import * as styles from "../tanks.module.scss";
import * as FileSaver from 'file-saver';
import { utils } from "../../../utils/utils";
import ModuleAccess from "../../controls/module_access.jsx"

const Columns = [
    {
        header: "TankOperation.fuelType",
        name: "fuelType"
    },
    {
        header: "TankOperation.provider",
        name: "provider"
    },
    {
        header: "TankOperation.description",
        name: "description"
    },
    {
        header: "TankOperation.balance",
        name: "balance",
        dataType: "float"
    },
    {
        header: "TankOperation.deliveryDate",
        name: "deliveryDate",
        dataType: "datetime"
    }
];

class TankDetails extends React.Component {
    constructor(props) {
        super(props);
        const tankId = parseInt(props.match.params.id);
        this.state = {
            tank: this.props.tank, operations: [], loading: false, filter: {
                pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
                modelFilter: { tankId: tankId }
            }
        };

        this.getTank = this.getTank.bind(this);
        this.editTank = this.editTank.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getOperations = this.getOperations.bind(this);
        this.addTankOperation = this.addTankOperation.bind(this);
        this.renderTank = this.renderTank.bind(this);
        this.renderTankOperations = this.renderTankOperations.bind(this);
    }

    componentDidMount() {
        let id = 0;
        id = parseInt(this.props.match.params.id);
        this.props.getTank(id);//.state.tank.tankId);
        this.getOperations(this.state.filter);
    }

    getTank(tankId) {
        this.props.getTank(tankId)
            .then(tank => {
                    this.setState({ ...this.state, tank: tank });
                }
            );
    }

    getReport() {
        this.props.getOperationsReport(this.state.filter).then(data => {
            FileSaver.saveAs(data, 'tanks_operations.xlsx');
        });
    }

    getOperations(filter) {
        this.setState({ ...this.state, loading: true });
        this.props.getTankOperations(filter).then(tankOperations => {
            this.setState({ ...this.state, loading: false });
            if (!tankOperations) return;
            this.setState({
                ...this.state,
                operations: tankOperations.items,
                filter: tankOperations.filter
            });
        });
    }

    addTankOperation() {
        this.props.history.push('/tanks/' + this.props.tank.tankId + '/addtankoperation');
    }

    editTank() {
        this.props.history.push('/tanks/edittank/' + this.props.tank.tankId);
    }

    renderTank() {
        const tank = this.props.tank;
        if (!tank) return <div></div>;
        return (
            <div className={[styles.tank_view_item, styles.tank_details_view_item].join(' ')}>
                <div>
                    <div className={styles.tank_header}>{tank.tankName}</div>
                    <TankLevel
                        minLevel={tank.minLevel}
                        maxLevel={tank.maxLevel}
                        level={tank.volume}
                        width="140"
                        height="200" />
                </div>
                <div className={styles.tank_details_info_container}>
                    <div className={styles.tank_details_info}>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.department</Trans><span>: </span><span>{tank.department}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.fuelType</Trans><span>: </span><span>{tank.fuelType}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.Details.maxLevel</Trans><span>:</span></div>
                            <div>{tank.maxLevel}</div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.Details.calculatedVolume</Trans><span>:</span></div>
                            <div>{tank.volume && tank.volume.toFixed(2)}</div>
                        </div>
                    </div>
                    {tank.lastLevelsState && <div className={styles.tank_details_info}>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.watterLevelHeight</Trans><span>: </span><span>{tank.lastLevelsState.watterLevelHeight}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.watterLevelVolume</Trans><span>: </span><span>{tank.lastLevelsState.watterLevelVolume}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.productLevelHeight</Trans><span>: </span><span>{tank.lastLevelsState.productLevelHeight}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.productLevelVolume</Trans><span>: </span><span>{tank.lastLevelsState.productLevelVolume}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.temperature</Trans><span>: </span><span>{tank.lastLevelsState.temperature}</span><span>&#730;C</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.density</Trans><span>: </span><span>{tank.lastLevelsState.density}</span><span><Trans>TankStateOperation.densityUnit</Trans></span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.weight</Trans><span>: </span><span>{tank.lastLevelsState.weight}</span><span><Trans>TankStateOperation.weightUnit</Trans></span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.packageTs</Trans><span>: </span><span>{utils.formatDate(new Date(tank.lastLevelsState.packageTs.split('.')[0] + ".000Z"))}</span></div>
                        </div>
                    </div>}
                    <div className={styles.edit_tank_buttons_container}>
                        <button className={styles.add_operation_button} onClick={this.addTankOperation}></button>
                        <ModuleAccess moduleName="Tanks" access='2'>
                            <button className={styles.edit_tank_button} onClick={this.editTank}></button>
                        </ModuleAccess>
                    </div>
                   
                    
                </div>
            </div>
        );
    }

    renderTankOperations() {
        return (
            <div>
                <Table settings={{
                        columns: Columns,
                        items: this.state.operations,
                        itemsFilter: this.state.filter,
                        isEditable: false,
                        getItemsFunction: this.getOperations,
                        getReportFunction: this.getReport
                    }}/>
            </div>
        );
    }

    render() {
        return (
            <div className={styles.tank_details_container}>
                <div>
                    {
                        this.renderTank()
                    }
                </div>
                <div>
                    {
                        this.renderTankOperations()
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let id = parseInt(ownProps.match.params.id);
    if (!id) return { item: null };
    let tanks = [];
    state.tanks.areas.map(area => area.tanks.map(tank => tanks.push(tank)));

    return {
        ...ownProps,
        tank: state.tanks.currentTank,// tanks.find(tank => tank.tankId === id)
    };
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        getTank: tankId => dispatch(actionTanks.getTank(tankId)),
        getTankOperations: filter => dispatch(actionTanks.getTankOperations(filter)),
        getOperationsReport: filter => dispatch(actionTanks.getOperationsReport(filter))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation('translantions')(TankDetails)));